export default {
  type: "Feature",
  properties: {
    name: "Арвайхээр",
    location: [45.15721721768806, 102.36120303338531],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [101.28849506378174, 46.826199106709744],
        [101.41342163085938, 46.84798223530896],
        [101.62628173828125, 46.85173907873366],
        [101.77047729492188, 46.862069043222895],
        [101.81991577148438, 46.87239702052007],
        [101.84738159179686, 46.88460024993555],
        [101.87759399414062, 46.92963428624288],
        [101.92291259765625, 46.961510504873075],
        [102.00256347656249, 46.98118927533914],
        [102.09869384765625, 46.99524110694596],
        [102.14263916015625, 47.01116205043071],
        [102.26486206054688, 47.02614213366051],
        [102.29644775390625, 47.02614213366051],
        [102.32940673828125, 47.01116205043071],
        [102.40493774414062, 46.95776134668866],
        [102.46536254882812, 46.930572093016316],
        [102.51205444335938, 46.953074529521054],
        [102.54226684570312, 47.00179736417431],
        [102.557373046875, 47.080409706315635],
        [102.58621215820312, 47.12901644660399],
        [102.64251708984374, 47.15517092451596],
        [102.68783569335938, 47.18877920473518],
        [102.72628784179688, 47.23915174981453],
        [102.72628784179688, 47.25779610603277],
        [102.72079467773436, 47.28202395793543],
        [102.68783569335938, 47.30903424774781],
        [102.65350341796875, 47.333238640473475],
        [102.6397705078125, 47.366734109127115],
        [102.65075683593749, 47.39091206104779],
        [102.68096923828124, 47.40764414848437],
        [102.71392822265625, 47.41322033016902],
        [102.755126953125, 47.37975438400816],
        [102.843017578125, 47.37231462056695],
        [102.886962890625, 47.357431944587034],
        [102.952880859375, 47.32579231609051],
        [103.03802490234375, 47.31275872224939],
        [103.13690185546875, 47.23262467463881],
        [103.1890869140625, 47.204642388766935],
        [103.34701538085938, 47.18737928434322],
        [103.44589233398436, 47.18457933279251],
        [103.52073669433594, 47.18737928434322],
        [103.59214782714844, 47.201843347946806],
        [103.63746643066406, 47.219101747038245],
        [103.67729187011719, 47.250805241535076],
        [103.67712020874023, 47.25068871930782],
        [103.77685546875, 47.26338813315705],
        [103.86474609375, 47.25593196573788],
        [103.93890380859375, 47.26432008025478],
        [104.04876708984375, 47.27922900257082],
        [104.14764404296874, 47.29809208596965],
        [104.14833068847656, 47.29879058949732],
        [104.1448974609375, 47.25919416818626],
        [104.15313720703125, 47.21583707523794],
        [104.17098999023436, 47.1607737815166],
        [104.20120239257811, 47.124344650121884],
        [104.249267578125, 47.09537035351024],
        [104.31106567382811, 47.05608969226366],
        [104.33578491210938, 47.034566583590426],
        [104.3536376953125, 46.997114405385986],
        [104.35638427734375, 46.95869866086379],
        [104.34539794921875, 46.903369029728054],
        [104.30145263671875, 46.89680070399431],
        [104.2657470703125, 46.87990702860919],
        [104.23416137695312, 46.853617401905105],
        [104.32342529296875, 46.76996843356982],
        [104.34814453125, 46.73233101286786],
        [104.3756103515625, 46.70408569832255],
        [104.39208984375, 46.65697731621612],
        [104.39208984375, 46.569246469250054],
        [104.403076171875, 46.52863469527167],
        [104.43878173828125, 46.50595444552051],
        [104.56512451171875, 46.443534945303284],
        [104.60769653320311, 46.417979059090115],
        [104.6531867980957, 46.380570155101864],
        [104.65576171875, 46.3810438458062],
        [104.6063232421875, 46.22165245637913],
        [104.5513916015625, 46.137976523476574],
        [104.43603515624999, 46.12274903582433],
        [104.3096923828125, 46.13036330589103],
        [104.2437744140625, 46.01603873833416],
        [104.1888427734375, 45.98169518512228],
        [104.12841796875, 45.81348649679971],
        [104.073486328125, 45.74836030216746],
        [103.8262939453125, 45.74836030216746],
        [103.71093749999999, 45.7176863579072],
        [103.623046875, 45.625563438215956],
        [103.623046875, 45.521743896993634],
        [103.6834716796875, 45.413876460821086],
        [103.77685546875, 45.37144349133922],
        [103.798828125, 45.33284041773058],
        [103.7823486328125, 45.27488643704894],
        [103.7823486328125, 45.168967697945575],
        [103.7823486328125, 45.17041997262667],
        [103.71093749999999, 45.06770141120143],
        [103.5736083984375, 44.96674121705534],
        [103.35113525390625, 44.88506649401471],
        [103.31817626953125, 44.824708282300236],
        [103.2440185546875, 44.80132682904856],
        [103.07922363281249, 44.555249259710656],
        [103.03802490234375, 44.439663223436106],
        [102.9638671875, 44.36902359940364],
        [102.93365478515625, 44.314022698837775],
        [102.93365478515625, 44.264871151101985],
        [102.996826171875, 44.15462243076731],
        [102.3870849609375, 44.156592967556605],
        [102.06298828125, 44.11716972942086],
        [101.80755615234375, 44.050089820756796],
        [101.80789947509764, 44.048917712794136],
        [101.7828369140625, 44.083146046165986],
        [101.68395996093749, 44.382765762252404],
        [101.62353515625, 44.535674532413196],
        [101.5960693359375, 44.574817404670306],
        [101.53564453124999, 44.64911632343077],
        [101.5521240234375, 44.766236875162335],
        [101.5850830078125, 44.809121700077355],
        [101.5576171875, 44.867549659447214],
        [101.3653564453125, 44.94536144236941],
        [101.1895751953125, 44.999767019181306],
        [101.129150390625, 45.089035564831036],
        [101.151123046875, 45.47939202177826],
        [101.2335205078125, 45.55252525134013],
        [101.2445068359375, 45.6178796835697],
        [101.3214111328125, 45.75985868785574],
        [101.29394531249999, 45.84410779560204],
        [101.27197265625, 45.96642454131025],
        [101.2994384765625, 46.06179698466216],
        [101.42578124999999, 46.115133713265415],
        [101.49169921875, 46.195042108660154],
        [101.4971923828125, 46.3810438458062],
        [101.524658203125, 46.46056554578543],
        [101.49993896484375, 46.50689964492765],
        [101.47933959960938, 46.54658317951774],
        [101.49856567382812, 46.580574564531695],
        [101.436767578125, 46.638122462379656],
        [101.28851652145386, 46.82616974343502],
        [101.28849506378174, 46.826199106709744],
      ],
    ],
  },
};
